import { render, staticRenderFns } from "./OrderZipInfo.vue?vue&type=template&id=0e7b61fd&"
import script from "./OrderZipInfo.vue?vue&type=script&lang=js&"
export * from "./OrderZipInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports